import React from 'react';
import axios from "../../../../../containers/api";
import {showCatchError} from "../../../../../helpers/Utils";
import {Button, CardBody, Row, Alert, FormGroup, Label, CustomInput} from "reactstrap";
import {Colxx} from "../../../../../components/common/CustomBootstrap";
import Autocomplete from "@mui/material/Autocomplete";
import TextField from "@mui/material/TextField";

class AddLoadHallShowTime extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            errors: [],
            ShowTimeSearchTypes: this.props.ShowTimeSearchTypes,
           
            
            selectedshowTime: { value: null, text: '' },
           
        }
    }

    validate = () => {
        this.props.closeSweetAlert();
        let error = [];
        if (this.state.selectedshowTime.value === null) {
            error.push("انتخاب ساعت الزامي ميباشد.");
        }
         

        this.setState({errors: error});
        if (error.length === 0) {
            this.submitForm();
        } else {
            this.props.showAlert("لطفا تمامی اطلاعات درخواست شده را به درستی وارد کنید!", "error");
        }
    };

    submitForm = () => {
        const model = {
            ShowTime: this.state.selectedshowTime.value,
            IsActive: true,
           
        };

        this.props.showSpinner();
        axios.post('/api/v1/load-hall-showtimes/AddLoadHallShowTime', model)
            .then((res) => {
                this.props.hideSpinner();
                if (res.status === 200) {
                    this.props.showAlert(res.data.message, "success");
                    this.props.closeModal("AddModal");
                } else {
                    this.props.showAlert("خطا در ثبت ساعت اعلام بار", "error");
                }
            })
            .catch((error) => {
                this.props.hideSpinner();
                console.log(error.response)
                this.props.showAlert(showCatchError(error), "error");
            });
    }

    selectHandleChange = (event, value, name) => {
        this.setState({[name]: value });
    };

    render() {
        return (
            <Row className="d-flex justify-content-center">
                <Colxx md="10" xxs="12">
                    <CardBody className="d-flex flex-column">
                        <div className="d-flex flex-md-row flex-column flex-wrap justify-content-center mt-3">
                            <FormGroup className="w-md-30 w-100 px-1">
                                <Label>ساعت</Label>
                                <Autocomplete
                                    disableClearable
                                    clearText={"حذف"}
                                    closeText={"بستن"}
                                    noOptionsText={"در حال دریافت اطلاعات.."}
                                    openText={"باز کردن"}
                                    className="react-select__control"
                                    id="selectedshowTime"
                                    options={this.state.ShowTimeSearchTypes}
                                    getOptionLabel={(option) => option.text}
                                    value={this.state.selectedshowTime}
                                    onChange={(e, v) => this.selectHandleChange(e, v, "selectedshowTime")}
                                    renderInput={(params) => (<TextField{...params} variant="standard"/>)}
                                />
                            </FormGroup>

                             
                        </div>

                        {this.state.errors.length === 0 ?
                            null
                            :
                            <div>
                                {(this.state.errors.map((error, i) => {
                                    return (
                                        <Alert color="danger" key={i}>{error}</Alert>
                                    )
                                }))}
                            </div>
                        }

                        <div className="d-flex mt-2 justify-content-center">
                            <FormGroup className="text-center">
                                <Button color="primary" className="btn-lg mx-2"
                                        onClick={() => this.props.showSweetAlert("آیا از صحت اطلاعات وارد شده اطمینان دارید؟", "", "warning", this.validate)}>
                                    ثبت
                                </Button>
                            </FormGroup>
                        </div>
                    </CardBody>
                </Colxx>
            </Row>
        );
    }
}

export default AddLoadHallShowTime;